import Component_BasicAnimations_afa6390570a09ff6c0e0fa1599695381 from "../../../../content/examples/basic/animations/BasicAnimations";
import Devtool_BasicAnimations_afa6390570a09ff6c0e0fa1599695381 from "!!@devtool/loader!../../../../content/examples/basic/animations/BasicAnimations";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_BasicAnimations_afa6390570a09ff6c0e0fa1599695381,
  Devtool_BasicAnimations_afa6390570a09ff6c0e0fa1599695381,
  DevTool,
  React
};